import type { Hazard, Point } from "./models";

export class SpecialDiamondSystem {
  removeNearestHazard(hazards: Hazard[], origin: Point, minimumRemaining: number): Hazard[] {
    if (hazards.length <= minimumRemaining) return hazards;
    let nearestIndex = 0;
    let nearestDistance = Number.POSITIVE_INFINITY;
    hazards.forEach((hazard, index) => {
      const distance = Math.hypot(hazard.position.x - origin.x, hazard.position.y - origin.y);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = index;
      }
    });
    return hazards.filter((_, index) => index !== nearestIndex);
  }

  grantShield(currentCharges: number): number {
    return Math.min(1, currentCharges + 1);
  }

  consumeShield(currentCharges: number): { blocked: boolean; charges: number } {
    return currentCharges > 0
      ? { blocked: true, charges: currentCharges - 1 }
      : { blocked: false, charges: 0 };
  }
}
